import { FC, useState } from 'react';

import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Button from 'components/button';
import { IImage } from './ImageSorter';
import { GEMINI_IMPROVE_IMAGE_PROMPT, GPT_IMAGE_2_5_IMPROVE_IMAGE_PROMPT } from 'components/constants-ts';
import { AI_MODEL, AiModelDropdown } from './GenerateEnvAIModal';

interface ImproveAiPromptModalProps {
  imageData: IImage;
  onClose: () => void;
  onSubmit: (param: { prompt: string, model: AI_MODEL }) => void;
}

export const ImproveAiPromptModal: FC<ImproveAiPromptModalProps> = ({ imageData, onSubmit, onClose }) => {
  const [legacyPrompt, setLegacyPrompt] = useState(GEMINI_IMPROVE_IMAGE_PROMPT);
  const [transparentPrompt, setTransparentPrompt] = useState(GPT_IMAGE_2_5_IMPROVE_IMAGE_PROMPT);
  const [model, setModel] = useState(AI_MODEL.sunburst);
  const transparentModel = model === AI_MODEL.sunburst || model === AI_MODEL.flare;
  const prompt = transparentModel ? transparentPrompt : legacyPrompt;

  const handleSubmit = () => {
    onClose();
    onSubmit({ prompt, model });
  };

  return (
    <Dialog
      open
      PaperProps={{ style: { maxWidth: 900, width: '100%', maxHeight: 700, height: '100%' } }}
      onAbort={onClose}
    >
      <DialogTitle>Förbättra bild</DialogTitle>

      <DialogContent>
        <Box
          display="flex"
          gridGap={24}
          flexDirection={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'center', md: 'start' }}
          style={{ height: "calc(100% - 80px)" }}
        >
          <Box flexShrink={0} display="flex" alignItems="start" justifyContent="center" width={{ xs: '100%', md: 150 }}>
            <img src={imageData.imgSrc} alt="" style={{ maxWidth: '100%', maxHeight: '100%' }} />
          </Box>

          <TextField
            fullWidth
            multiline
            label="Prompt"
            variant="outlined"
            style={{ height: '100%' }}
            value={prompt}
            onChange={event => transparentModel ? setTransparentPrompt(event.target.value) : setLegacyPrompt(event.target.value)}
            InputProps={{ style: { height: '100%' } }}
            inputProps={{ style: { height: '100%', overflow: 'auto' } }}
          />
        </Box>
        <Box display="flex" mt={2} justifyContent="end" gridGap={16}>
          <AiModelDropdown model={model} setModel={setModel} />
        </Box>
      </DialogContent>

      <DialogActions>
        <Box display="flex" gridGap={16} px={2} py={1}>
          <Button size="small" color="primary" onClick={onClose}>
            Avbryt
          </Button>
          <Button size="small" variant="contained" color="primary" onClick={handleSubmit}>
            Förbättra
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ImproveAiPromptModal;
